import React, { useEffect } from 'react';
import * as microsoftTeams from '@microsoft/teams-js';

const TeamsConfig = () => {
  useEffect(() => {
    const initializeConfig = async () => {
      try {
        await microsoftTeams.app.initialize();
        
        // Register configuration handler
        microsoftTeams.pages.config.registerOnSaveHandler((saveEvent) => {
          // Set configuration values
          microsoftTeams.pages.config.setConfig({
            entityId: 'ExpenseTracker',
            contentUrl: `${window.location.origin}/`,
            suggestedDisplayName: 'Expense Tracker Pro',
            websiteUrl: `${window.location.origin}/`,
          });
          
          saveEvent.notifySuccess();
        });

        // Set initial valid state
        microsoftTeams.pages.config.setValidityState(true);
      } catch (error) {
        console.error('Failed to initialize Teams config:', error);
      }
    };

    initializeConfig();
  }, []);

  return (
    <div className="min-h-screen bg-gradient-surface flex items-center justify-center p-8">
      <div className="max-w-md mx-auto text-center">
        <h1 className="text-2xl font-bold text-foreground mb-4">
          Configure Expense Tracker Pro
        </h1>
        <p className="text-muted-foreground mb-6">
          Click "Save" to add the Expense Tracker Pro app to your team or channel.
        </p>
        <div className="bg-card rounded-lg p-6 border">
          <p className="text-sm text-muted-foreground">
            This will add a tab where team members can track and manage expenses collaboratively.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TeamsConfig;